import { ResourceOptions } from 'react-admin';
import { FaFlag } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.redpacketFeatureFlags;
export const icon = FaFlag;
export const options: ResourceOptions = {
  label: 'module.redpacket.featureFlags',
};
